export const data = [
  {
    id: 1,
    title: "Restaurant Delight",
    description: "A fine dining experience with exotic cuisines. ",
    images:
      "https://img.freepik.com/free-photo/view-tank-container-water-storage_23-2151748303.jpg?uid=R197373896&ga=GA1.1.522528783.1742961482&semt=ais_hybrid&w=740",
  },
  {
    id: 2,
    title: "Urban Bites",
    description: "Quick snacks and beverages for city folks. ",
    images:
      "https://img.freepik.com/free-photo/beautiful-scenery-mangal-das-garcas-park-city-belem-brazil_181624-31712.jpg?uid=R197373896&ga=GA1.1.522528783.1742961482&semt=ais_hybrid&w=740",
  },
  {
    id: 3,
    title: "Green Spoon",
    description: "Healthy meals with organic ingredients. ",
    images:
      "https://img.freepik.com/free-photo/view-island-middle-lake_181624-19253.jpg?uid=R197373896&ga=GA1.1.522528783.1742961482&semt=ais_hybrid&w=740",
  },
  {
    id: 4,
    title: "Ocean View Cafe",
    description: "Coastal vibes with seafood specials. ",
    images:
      "https://img.freepik.com/free-photo/umbrella-pool-chair_74190-1611.jpg?uid=R197373896&ga=GA1.1.522528783.1742961482&semt=ais_hybrid&w=740",
  },
  {
    id: 5,
    title: "Pizza Point",
    description: "Serving cheesy slices with fresh toppings. ",
    images:
      "https://img.freepik.com/free-photo/view-tank-container-water-storage_23-2151748303.jpg?uid=R197373896&ga=GA1.1.522528783.1742961482&semt=ais_hybrid&w=740",
  },
  {
    id: 6,
    title: "The Burger Hub",
    description: "Grilled burgers and crispy fries served hot. ",
    images:
      "https://img.freepik.com/free-photo/view-tank-container-water-storage_23-2151748303.jpg?uid=R197373896&ga=GA1.1.522528783.1742961482&semt=ais_hybrid&w=740",
  },
];
